import { errorCodeOf, statusOf } from './httpStatus';

/** The grant (`POST /v1/permission`) and the confirmation both answer a refusal with 409. */
const HTTP_CONFLICT = 409;

/**
 * The `errorCode` person-api supplies on the 409 for a confirmation or a grant for a customer who
 * already holds a photo card or ImmiCard, for an organisation code that has not opted into that
 * type. It is listed on each endpoint that carries it in `openapi.yaml`. Matched by this code,
 * never by the message.
 */
export const HELD_DOCUMENT_TYPE_NOT_ACCEPTED_CODE = 'HELD_DOCUMENT_TYPE_NOT_ACCEPTED';

/** Whether a failed request is person-api's held document type refusal: a 409 carrying its code. */
export const isHeldDocumentTypeRefusal = (error: unknown): boolean =>
  statusOf(error) === HTTP_CONFLICT && errorCodeOf(error) === HELD_DOCUMENT_TYPE_NOT_ACCEPTED_CODE;
